/**
 * De taalmodellen waaruit een beheerder kan kiezen voor de factuuranalyse.
 *
 * Een vaste lijst en geen vrij tekstveld: een typefout in een modelnaam levert
 * een 400 op halverwege een upload. Dan staat de gebruiker met een afgewezen
 * factuur zonder te weten waarom. Dezelfde afweging als in VIP.
 *
 * Alle vijf lezen PDF's als beeld en geven structured outputs via de Responses
 * API. Prijzen per miljoen tokens (invoer / uitvoer), gecontroleerd op
 * 22-09-2026. Wat de gateway aanbiedt is op te vragen met GET /openai/models.
 */
export const TAALMODELLEN = [
    {
        id: 'gpt-6-astra',
        naam: 'GPT-6 Astra',
        omschrijving: 'Krachtigst. $10 / $50 per miljoen tokens; voor een factuur overkill.',
    },
    {
        id: 'gpt-5.6-sol',
        naam: 'GPT-5.6 Sol',
        omschrijving: 'Voor professioneel werk. $4 / $20.',
    },
    {
        id: 'gpt-5.6-terra',
        naam: 'GPT-5.6 Terra',
        omschrijving: 'Balans tussen kwaliteit en prijs. $2 / $12.',
    },
    {
        id: 'gpt-5.6-luna',
        naam: 'GPT-5.6 Luna',
        omschrijving: 'Snelst en goedkoopst van de 5.6-reeks. $0,20 / $1,20.',
    },
    {
        id: 'gpt-5.4-mini',
        naam: 'GPT-5.4 Mini',
        omschrijving: 'Vorige generatie, klein. $0,75 / $4,50.',
    },
];
/** Wat er draait als er niets is ingesteld. */
export const STANDAARD_TAALMODEL = 'gpt-5.6-terra';
export function isTaalmodel(ruw) {
    return TAALMODELLEN.some((m) => m.id === ruw);
}
/** Alleen een naam uit de lijst; al het andere valt terug op de standaard. */
export function leesTaalmodel(ruw) {
    return isTaalmodel(ruw) ? ruw : STANDAARD_TAALMODEL;
}
/**
 * Hoe lang het model mag nadenken voordat het antwoordt.
 *
 * De GPT-5-modellen redeneren in stilte en die denkstappen worden als
 * uitvoertokens afgerekend, dus dit is ook een kostenknop. `medium` is wat
 * OpenAI zelf standaard doet; `low` is voor een leesbare factuur meestal
 * genoeg, `high` helpt bij een rommelige scan maar kost meer tijd en geld.
 */
export const REDENEERNIVEAUS = [
    {
        id: 'low',
        naam: 'Laag',
        omschrijving: 'Snel en goedkoop. Genoeg voor een nette, leesbare factuur.',
    },
    {
        id: 'medium',
        naam: 'Gemiddeld',
        omschrijving: 'De standaard van OpenAI. Balans tussen zorgvuldigheid en kosten.',
    },
    {
        id: 'high',
        naam: 'Hoog',
        omschrijving: 'Grondig, voor rommelige of ongewone facturen. Trager en duurder.',
    },
];
export const STANDAARD_REDENEERNIVEAU = 'medium';
export function isRedeneerniveau(ruw) {
    return REDENEERNIVEAUS.some((n) => n.id === ruw);
}
/** Alleen een niveau uit de lijst; al het andere valt terug op de standaard. */
export function leesRedeneerniveau(ruw) {
    return isRedeneerniveau(ruw) ? ruw : STANDAARD_REDENEERNIVEAU;
}
/**
 * Plafond voor nadenken plus antwoord samen, per aanroep.
 *
 * Het antwoord zelf is een klein JSON-object; wat er verder opgaat is
 * redeneren. Het plafond begrenst wat één factuur maximaal mag kosten, en het
 * model gebruikt het zelden helemaal. Te laag betekent een afgekapt antwoord en
 * dus een foutmelding voor de gebruiker; vandaar een ondergrens.
 */
export const AI_MAX_OUTPUT_TOKENS = { min: 1000, max: 32000, standaard: 8000 };
export function isGeldigMaxOutputTokens(ruw) {
    return (typeof ruw === 'number' &&
        Number.isInteger(ruw) &&
        ruw >= AI_MAX_OUTPUT_TOKENS.min &&
        ruw <= AI_MAX_OUTPUT_TOKENS.max);
}
/** Een geheel getal binnen de grenzen; al het andere valt terug op de standaard. */
export function leesMaxOutputTokens(ruw) {
    return isGeldigMaxOutputTokens(ruw) ? ruw : AI_MAX_OUTPUT_TOKENS.standaard;
}
//# sourceMappingURL=taalmodel.js.map